import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tab} from 'semantic-ui-react';

import type * as Types from '../../../state/runs/types';
import type * as QueryTypes from '../../../util/queryTypes';
import {OutliersPanelGroupingOptions} from '../../PanelGrouping/OutliersPanelGrouping';
import {PanelGroupingOptions} from '../../PanelGrouping/PanelGroupingOptions';
import {DEFAULT_LINE_PLOT_MAX_GROUP_RUNS} from '../../WorkspaceDrawer/Settings/runLinePlots/maxRunDefaults';
import {isPointVizFullFidelity} from '../../WorkspaceDrawer/Settings/types';
import {usePanelConfigContext} from '../PanelConfigContext';
import {usePanelGroupingSettings} from '../RunsLinePlotContext/usePanelGroupingSettings';
import {type RunsLinePlotConfig} from '../types';
import {isEmptyChart} from '../utils/checkTypes';

const ABSOLUTE_MAX_GROUP_RUNS = 200;

type EditGroupingTabProps = {
  config: RunsLinePlotConfig;
  updateConfig: (config: Partial<RunsLinePlotConfig>) => void;
  pageQuery: QueryTypes.Query;
  data: Types.Data;
};

export const EditGroupingTab = (props: EditGroupingTabProps) => {
  const {pointVisualizationMethod} = usePanelConfigContext();
  const isBucketing = isPointVizFullFidelity(pointVisualizationMethod);
  const {isAnyRunsetGrouped: isGrouped} = usePanelGroupingSettings();
  const usingExpressions =
    props.config.expressions != null &&
    props.config.expressions.length > 0 &&
    !(
      props.config.expressions.length === 1 &&
      props.config.expressions[0] === ''
    );
  return (
    <Tab.Pane as="div" className="form-grid" data-test="grouping-tab">
      {isBucketing ? (
        <OutliersPanelGroupingOptions
          absoluteMaxGroupRuns={ABSOLUTE_MAX_GROUP_RUNS}
          config={props.config}
          defaultMaxGroupRuns={DEFAULT_LINE_PLOT_MAX_GROUP_RUNS}
          disabled={isEmptyChart(props.config)}
          isGrouped={isGrouped}
          pageQuery={props.pageQuery}
          type="lines"
          updateConfig={props.updateConfig}
          usingExpressions={usingExpressions}
        />
      ) : (
        <PanelGroupingOptions
          absoluteMaxGroupRuns={ABSOLUTE_MAX_GROUP_RUNS}
          config={props.config}
          defaultMaxGroupRuns={DEFAULT_LINE_PLOT_MAX_GROUP_RUNS}
          disabled={isEmptyChart(props.config)}
          isGrouped={isGrouped}
          pageQuery={props.pageQuery}
          type="lines"
          updateConfig={props.updateConfig}
          usingExpressions={usingExpressions}
          windowing={props.config.windowing}
        />
      )}
    </Tab.Pane>
  );
};
